import { Box, Flex } from '@radix-ui/themes';
import type { ComponentProps } from 'react';
import { Logo } from './Logo';
import Styles from './header.module.scss';
import { cn } from '~/utils/classNames';
type HeaderProps = ComponentProps<typeof Flex> & {
  disableLink?: boolean;
  href?: string;
};

export function Header({ href = '/', disableLink = false, className, children }: HeaderProps) {
  return (
    <Flex
      asChild
      width="100%"
      justify="between"
      align="center"
      gap="2"
      height="5.5rem"
      px="2"
      className={cn(Styles.Header, className)}
    >
      <nav>
        <Flex align="center" justify="between" width="100%">
          <Logo component="img" appearance="dark" href={href} />
          <Box>{children}</Box>
        </Flex>
      </nav>
    </Flex>
  );
}
